
import { InjectionToken } from '@angular/core';
import { TechpubsConfig } from './techpubs-config';

export const APP_CONFIG = new InjectionToken<TechpubsConfig>('app.config');
